module.exports = __webpack_public_path__ + "fonts/GothamSSm-Bold.5d2c32ea.ttf";